const RowEditorComponent = {
    templateUrl: '/formViewer/editor/row/rowEditor.tpl.html',
    controller: 'rowEditorController',
    bindings: {
        rowStructure: '<',
        rootFormId: '<'
    }
};

angular.module('umFormViewer')
    .component('uiRowEditor', RowEditorComponent);
